module.exports = __webpack_public_path__ + "static/img/tkbj_jqts_icon.png";